<template>
  <div class="contract-finance-view">
    <div class="table-wrap">
      <el-table v-if="pageData" v-loading="loading" :data="pageData.list" height="680px">
        <el-table-column prop="party_a" label="客户名称" align="center" width="200"></el-table-column>
        <el-table-column prop="project_name" label="项目名称" align="center" width="200"></el-table-column>
        <el-table-column prop="entry_type_name" label="业务类型" align="center" width="80"></el-table-column>
        <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
        <el-table-column prop="amount" label="合同金额" align="center"></el-table-column>
        <el-table-column prop="symbol_name" label="变动原因" align="center" width="200"></el-table-column>
        <el-table-column prop="symbol_amount" label="变动金额" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.symbol_amount!=0&&scope.row.symbol_value=='-'" style="color: #ff3d00">{{ scope.row.symbol_value }} {{scope.row.symbol_amount}}</span>
            <span v-if="scope.row.symbol_amount!=0&&scope.row.symbol_value=='+'" style="color: #28af05">{{ scope.row.symbol_value }} {{scope.row.symbol_amount}}</span>
            <span v-if="scope.row.symbol_amount==0" style="color: #606060">{{scope.row.symbol_amount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="invoice_amount" label="应收金额" align="center"></el-table-column>
        <el-table-column prop="status" label="是否审核" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.check_status > 0 ?'success':'danger'">{{ scope.row.check_status > 0 ? '已审':'未审'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" align="center" width="100"></el-table-column>
        <el-table-column prop="update_time" label="修改时间" align="center" width="100"></el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrap" v-if="pageData && pageData.total > 0">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pageData.total*1"
        :page-size="pageData.pageSize*1"
        :current-page="pageData.page*1"
        @current-change="pageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import CommonHelp from "./common/CommonHelp";

export default {
  name: "ContractFinanceView",
  data() {
    return {
      loading: false,
      pageData: null,
      ids: '',
      currentPage: 1,
      pageSize: 15
    };
  },
  mounted() {
    // 从URL获取ids参数
    this.getIdsFromUrl();
    console.log('获取到的ids:', this.ids); // 调试输出
    // 加载数据
    if (this.ids) {
      this.getList();
    } else {
      console.warn('未获取到ids参数');
    }
  },
  methods: {
    // 从URL获取ids参数
    getIdsFromUrl() {
      // 方式1: 尝试从路由参数获取
      if (this.$route && this.$route.query && this.$route.query.ids) {
        this.ids = this.$route.query.ids;
        return;
      }

      // 方式2: 尝试从路由params获取
      if (this.$route && this.$route.params && this.$route.params.ids) {
        this.ids = this.$route.params.ids;
        return;
      }

      // 方式3: 从URL查询字符串获取
      const urlParams = new URLSearchParams(window.location.search);
      this.ids = urlParams.get('ids') || '';

      // 方式4: 从完整URL中解析
      if (!this.ids) {
        const url = window.location.href;
        const match = url.match(/[?&]ids=([^&]+)/);
        if (match && match[1]) {
          this.ids = decodeURIComponent(match[1]);
        }
      }
    },

    // 获取列表数据
    getList() {
      var that = this;
      that.loading = true;

      const where = {
        _ids: this.ids
      };

      CommonHelp.get("Finance/getList", {
        where: JSON.stringify(where),
        page: this.currentPage,
        page_size: this.pageSize
      }, res => {
        if (res.code) {
          res.data.list.map(ret => {
            ret.is_end = ret.is_end === 1;
            ret.is_invoice = ret.is_invoice === 1;
            ret.is_paid = ret.is_paid === 1;
            return ret;
          });
          that.pageData = res.data;
          setTimeout(function () {
            that.$forceUpdate();
          }, 200);
        }
        that.loading = false;
      });
    },

    // 分页改变
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    }
  }
};
</script>

<style scoped lang="scss">
.contract-finance-view {
  padding: 20px;

  .table-wrap {
    margin-bottom: 20px;
  }

  .pagination-wrap {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ContractFinanceView.vue